export class HelperService {

  // Private static instance of the class (singleton)
  private static instance: HelperService;
  
  // Private constructor to prevent direct instantiation
  private constructor() {
  }

  // Method to return the singleton instance
  public static getInstance(): HelperService {
    if (!HelperService.instance) {
      HelperService.instance = new HelperService();
    }
    return HelperService.instance;
  }

  /** 
   * TEXT HELPERS
  **/

  public toCamelCase = (str: string | null | undefined): string => {
    if (!str) return 'unknown';
    return str
      .toLowerCase()
      .split(' ')
      .map((word, index) =>
        index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join('');
  };


  /** 
   * USER HELPERS
  **/

  public getAvatarLetters = (username: string,) => {
    // TODO getInitials from full name when available search in this app
    // const [firstName, lastName] = email.split(' ');
    // `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase();
    const result = username.charAt(0).toUpperCase();
    return result;
  };

  public getUserColor = (username: string = '?') => {
    const colors = ['#3F51B5', '#2196F3', '#009688', '#FF5722', '#795548', '#673AB7', '#E91E63', '#4CAF50', '#FF9800', '#9C27B0'];
    const hash = username.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return colors[hash % colors.length];
  };


  /** 
   * DATE HELPERS
  **/

  public formatDutchDate = (dateString?: string | null) => {
    if (!dateString) return '';
    return new Intl.DateTimeFormat('nl-NL', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(new Date(dateString));
  };
};

// Export an instance of the navigationService class
export const helperService = HelperService.getInstance();
